import Vue from 'vue';
import Router from 'vue-router';
import i18n from '../i18n/index';
import Dashboard from '../pages/Dashboard';
import PageNotFound from '../pages/ErrorPages/PageNotFound';
import SupplierPayments from '../pages/Payments/SupplierPayments';
import ClientPayments from '../pages/Payments/ClientPayments';
import GiftVoucherList from '../pages/gift-vouchers/GiftVoucherList';
import { session } from './middleware';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
    },
    {
      path: '/payments/supplier-payments',
      name: 'SupplierPayments',
      component: SupplierPayments,
      meta: {
        title: i18n.t('pages.supplierPayments'),
      },
    },
    {
      path: '/payments/client-payments',
      name: 'ClientPayments',
      component: ClientPayments,
      meta: {
        title: i18n.t('pages.clientPayments'),
      },
    },
    {
      path: '/gift-vouchers/search',
      name: i18n.t('menu.giftVouchers.pages.search.title'),
      component: GiftVoucherList,
      meta: {
        title: i18n.t('menu.giftVouchers.pages.search.title'),
      },
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'Twenty Accounting';
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js